<div class="modal-overlay" *ngIf="isVisible" [class.active]="isVisible">
    <div class="modal">
      <div class="modal-header" style="background: #335596;">
        <h3 style="color: white; display: flex;align-items: center; gap: 8px;">
          <mat-icon>attach_file</mat-icon>
          Terms & Conditions</h3>
        
        <!-- <button class="close-modal" type="button" (click)="closeModals()">&times;</button> -->
      </div>
      <div class="modal-body">
        <p class="modal-subtitle">Please review and accept our updated terms and conditions to continue using the MPS portal.</p>

        <!-- PDF Viewer Section -->
        <div class="pdf-viewer-section">
          <div class="pdf-viewer-header">
            <div class="pdf-viewer-title">
              <mat-icon>picture_as_pdf</mat-icon>
              <span>Terms & Conditions Document</span>
            </div>
            <!-- <div class="pdf-viewer-controls">
              <button class="pdf-control-btn" (click)="zoomOut()" title="Zoom Out">
                <mat-icon>remove</mat-icon>
              </button>
              <span class="pdf-zoom-label">{{ Math.round(pdfZoom * 100) }}%</span>
              <button class="pdf-control-btn" (click)="zoomIn()" title="Zoom In">
                <mat-icon>add</mat-icon>
              </button>
              <button class="pdf-control-btn" (click)="resetZoom()" title="Reset Zoom">
                <mat-icon>fit_screen</mat-icon>
              </button>
            </div> -->
          </div>
          <div class="pdf-viewer-body">
            
            <ng-container *ngIf="userRole=='Owner'">
              <pdf-viewer
              [src]="buyerTermsUrl"
              [render-text]="false"
              [page]="1"
              [show-all]="true"
              [original-size]="false"
              class="pdf-viewer-content"
              >
              </pdf-viewer>
            </ng-container>

            <ng-container *ngIf="userRole=='Suppliers'">
              <pdf-viewer
              [src]="supplierTermsUrl"
              [render-text]="false"
              [page]="1"
              [show-all]="true"
              [original-size]="false"
              class="pdf-viewer-content"
              >
              </pdf-viewer>
            </ng-container>
          
          </div>
          <!-- <div class="pdf-viewer-footer">
            <mat-icon>info_outline</mat-icon>
            <span>Scroll through the document to read all terms before accepting.</span>
          </div> -->
        </div>

        <!-- Inline Terms (HTML fallback) -->
        <!-- <div class="terms-container">
            <div class="terms-box">
              <div [innerHTML]="termsContent"></div>
            </div>
        </div> -->

        <form>
          <div class="form-group">
            <label for="userFullName">Full Name *</label>
            <input
              id="userFullName"
              name="userFullName"
              type="text"
              class="form-control"
              placeholder="Please enter full name"
              [(ngModel)]="userFullName"
              required
            />
          </div>

          <div class="form-group">
            <label for="currentDate">Date *</label>
            <input
              id="date"
              name="currentDate"
              type="date"
              class="form-control"
              [(ngModel)]="currentDate"
              readonly
            />
          </div>
  
          
  
          <div class="form-group">
            <label>Signature Upload</label>
            <div
              class="file-upload"
              [class.drag-active]="dragActive"
              (click)="triggerFileBrowse(fileInput)"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave()"
              (drop)="onDrop($event)"
            >
              <i class="fas fa-cloud-upload-alt"></i>
              <p>Click to upload or drag and drop files</p>
              <p style="font-size: 14px; margin-top: 5px;">JPG, JPEG, PNG up to 10MB each</p>
            </div>
            <input #fileInput type="file" accept=".jpg,.jpeg,.png" style="display: none;" (change)="onFileChange($event)" />
           

            <div class="file-list" *ngIf="uploadedFiles.length">
              <div class="file-item" *ngFor="let file of uploadedFiles; let i = index">
            
                <!-- Top row -->
                <div class="file-header">
                  <div>
                    {{ file.name }} ({{ file.displaySize }})
                  </div>
            
                  <button
                    type="button"
                    class="remove-file"
                    (click)="removeFile(i)"
                    style="background:none; border:none; color:#dc3545; cursor:pointer;"
                  >
                  <i class="fas fa-times"></i>
                  </button>
                </div>
            
                <!-- Image preview -->
                <img
                  *ngIf="file.dataUrl"
                  [src]="file.dataUrl"
                  class="file-preview"
                  alt="preview"
                />
            
              </div>
            </div>

          </div>
  
         
          <div style="background: #f0f8ff; padding: 15px; border-radius: var(--border-radius); margin: 20px 0; border-left: 4px solid var(--secondary-blue);">
            <p style="font-size: 14px;">
              <strong>Note:</strong>
              Formal acknowlegement is required. Please type your full name upload an image of your signature
            </p>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <!-- <button class="cancel-btn" type="button" (click)="closeModals()">Ignore for Now</button> -->
        <button class="submit-btn" type="button" (click)="acceptTerms()">Accept Terms</button>
      </div>
    </div>
  </div>


  <div class="modal-overlay" [class.active]="showTermsSuccessPopup" *ngIf="showTermsSuccessPopup">
    <div class="successModal">
  
      <!-- Icon -->
      <div class="success-icon">🎉</div>
  
      <!-- Title -->
      <h2>Welcome to VSMPS Portal!</h2>
  
      <!-- Message -->
      <p>
        Thank you for signing the Terms and Conditions. Your agreement has been successfully recorded.
      </p>
      <p>
        You are now verified and granted full access to your dashboard.
      </p>
      <p>
        Welcome aboard — you can now manage your marine supply activities seamlessly.
      </p>
  
      <!-- Button -->
      <button class="success-btn" (click)="proceed()">
        Proceed to Dashboard
      </button>
  
    </div>
  </div>